import React, { useEffect, useRef, useState } from 'react'
import { EditUserDetails, EditUserEmailAddress, EditUserProfile, EditUserProfileImage, EditUserUsername, Loader, PageHeader, ViewUserProfile } from '../../../components'
import { AppDispatch, RootState } from '../../../reducers/store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { StateProfileParams } from '../../../types/profiles/profileParams';
import { actionFetchUser } from '../../../actions/users';
import { actionFetchUserProfile } from '../../../actions/profile';

import './editUser.css'

const EditUser = () => {
  const dispatch                                      = useDispatch<AppDispatch>();
  const navigate                                      = useNavigate();
  const { id }                                        = useParams()
  const { singleUser: userData }                      = useSelector((state: RootState) => state?.userList);
  const { isLoading, singleProfile: userProfileData } = useSelector((state: RootState) => state?.profileList);
  const [onePost, setOnePost]                         = useState<StateProfileParams>(); //or use the null below
  const [checkProfile, setCheckProfile]               = useState('')
  const lineRef                                       = useRef<HTMLDivElement | null>(null);
  const [activeTab, setActiveTab]                     = useState<number>(0);
  const tabButtons                                    = ['Profile', 'Edit User details', 'Edit profile', 'Edit Image', 'Edit Email', 'Edit Username'];

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  useEffect(() => {
    if (lineRef.current) {
      const parent = lineRef.current.parentNode as HTMLElement;
      const activeButton = parent.querySelector('.active') as HTMLElement;

      if (activeButton) {
        lineRef.current.style.width = `${activeButton.offsetWidth}px`;
        lineRef.current.style.left = `${activeButton.offsetLeft}px`;
      }
    }
  }, [activeTab]);

  useEffect(() => {
    if (id) {
      dispatch(actionFetchUser({ id }));
      dispatch(actionFetchUserProfile({ userId: id }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (!isLoading && id) {
      const profileUserId = userProfileData?.userId;

      if (!userProfileData || profileUserId !== id) {
        // Prevent rendering if we already navigated
        setCheckProfile('profile had not been created')
      } else {
        setOnePost(userProfileData);
      }
    }
  }, [id, userProfileData, isLoading, navigate]);

  return (
    <>
      <title>Edit Users</title>
      <PageHeader title="Edit Users" description="Welcome to the Users" download="Download Report" />

      <div className='user-profile-wrapper'>
        {isLoading ? (
            <Loader />
          ) : onePost ? (
            <>
              <div className='user-profile-body'>
                <div className='user-profile-tab-box'>
                  {tabButtons.map((tab, index) => (
                    <button key={index} className={`user-profile-tab-btn ${activeTab === index ? 'active' : ''}`} onClick={() => handleTabClick(index)} >
                      {tab}
                    </button>
                  ))}
                  <div className='user-profile-btn-line' ref={lineRef}></div>
                </div>

                <div className='user-profile-content-box'>
                  <div className={`user-profile-content ${activeTab === 0 ? 'active' : ''}`}>
                    <ViewUserProfile userProfileData={userProfileData} userData={userData} />
                  </div>
                  <div className={`user-profile-content ${activeTab === 1 ? 'active' : ''}`}>
                    <EditUserDetails id={id} userData={userData} />
                  </div>
                  <div className={`user-profile-content ${activeTab === 2 ? 'active' : ''}`}>
                    <EditUserProfile id={id} userProfileData={userProfileData} userData={userData}  />
                  </div>
                  <div className={`user-profile-content ${activeTab === 3 ? 'active' : ''}`}>
                    <EditUserProfileImage id={id} userProfileData={userProfileData} />
                  </div>
                  <div className={`user-profile-content ${activeTab === 4 ? 'active' : ''}`}>
                    <EditUserEmailAddress id={id}  userData={userData} /> 
                  </div>
                  <div className={`user-profile-content ${activeTab === 5 ? 'active' : ''}`}>
                    <EditUserUsername id={id} userData={userData} /> 
                  </div>
                </div>
              </div>
            </>
            )
           : (
            <><p>Empty data</p></>
            // <EmptyCard title="profile" linkName="Profile" link="/users/create-profile" />
        )}
      </div>
    </>
  )
}

export default EditUser